import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/attendance/AttendanceAction";
import * as uiHelpers from "../SectionsUIHelpers";
import {
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useSectionsUIContext } from "../SectionsUIContext";

export function SectionsTable({
  date
}) {
  // Sections UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      queryParams: sectionsUIContext.queryParams,
      setQueryParams: sectionsUIContext.setQueryParams,
      openStudentAbsenteeismsPage: sectionsUIContext.openStudentAbsenteeismsPage
    };
  }, [sectionsUIContext]);

  // Getting curret state of Sections list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.attendance }),
    shallowEqual
  );
  const { totalCount, dailyCourseHour, entities, listLoading } = currentState;
  
  // Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getSectionAttendances(sectionsUIProps.queryParams));
    return () => dispatch(actions.cleanAttendanceState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "section",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px"
      }
    }
  ];

  for (let i = 1; i <= dailyCourseHour; i++) {
    const column = {
      dataField: "courseHour" + i,
      text: i + ". Ders",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => {
        if (cell && cell.includes("Alındı")) {
          return (
            <Link to={"/sinif-yoklamalari/detay/" + row.id + "/" + date + "/" + i}>
              <div style={{ whiteSpace: "pre-wrap" }}>{cell}</div>
            </Link>
          );

        } else if (cell && cell.includes("Alınmadı")) {
          return (
            <div style={{ whiteSpace: "pre-wrap", fontWeight: "bold" }}>{cell}</div>
          );          
        }
      },
      style: {
        minWidth: "100px"
      }
    };
    columns.push(column);    
  }

  columns.push({
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      openStudentAbsenteeismsPage: sectionsUIProps.openStudentAbsenteeismsPage,
      date
    },
    classes: "text-center",
    headerClasses: "text-center",
    style: {
      width: "90px",
    }
  });

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: sectionsUIProps.queryParams.pageSize,
    page: sectionsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                sectionsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}